import { hash } from "@ember/helper";
import ComboBox from "discourse/select-kit/components/combo-box";

const AiLlmSelector = <template>
  <ComboBox
    @value={{@value}}
    @content={{@llms}}
    @onChange={{@onChange}}
    @options={{hash
      filterable=true
      none="discourse_ai.ai_agent.no_llm_selected"
    }}
    ...attributes
  />
</template>;

export default AiLlmSelector;
